export default {
    en: {
        SPLASH_BADGE: {
            VACR: 'Virginia Cyber Range',
            USCR: 'US Cyber Range'
        },
        SPLASH_TITLE_MAIN: 'CYBERSAFE',
        SPLASH_TITLE_ACCENT: 'AI',
        SPLASH_SUBTITLE: 'Practice AI and LLM safety through interactive challenges.',
        SPLASH_HINT: 'Press any key to continue',
    }
};
